import { render } from "./PointageDetailsPage.vue?vue&type=template&id=98f023b0&ts=true"
import script from "./PointageDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PointageDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__